import React, { FC } from 'react';
import Stepper from '@material-ui/core/Stepper';
import StepLabel from '@material-ui/core/StepLabel';
import { withStyles } from '@material-ui/styles';
import RetailStepIcon from './RetailStepIcon';
import RetailStepConnector from './RetailStepConnector';
import RetailStep4 from './RetailStep4';
import RetailStep5 from 'components/retail/atoms/RetailStepper/RetailStep5';
import { CustomerType } from 'services/orders/types';
import { makeStyles } from '@material-ui/core';

interface RetailStepperProps {
  activeStep: number;
  customerType: CustomerType;
  isZeroStep?: boolean;
}

const stepsByCustomerType = {
  [CustomerType.RESIDENTIAL]: ['Select Plan', 'Customer Information', 'Utility Account', 'Done'],
  [CustomerType.COMMERCIAL]: [
    'Select Plan',
    'Customer Information',
    'Utility Account',
    'Mailing/Billing Address',
    'Done',
  ],
};

const StyledStepper = withStyles((theme) => ({
  root: {
    backgroundColor: 'inherit',
    maxWidth: '95%',
    margin: '0 auto',
    [theme.breakpoints.up('sm')]: {
      maxWidth: '100%',
      padding: 0,
    },
  },
}))(Stepper);

const StyledStepLabel = withStyles((theme) => ({
  label: {
    fontSize: 13,
    // @ts-ignore
    fontWeight: '600 !important' as number,
    marginTop: '11px !important',
    color: '#93979b',
    [theme.breakpoints.up('sm')]: {
      fontSize: 16,
      marginTop: '15px !important',
    },
  },
  completed: {
    fontSize: 13,
    fontWeight: 600,
    color: '#000000 !important',
    [theme.breakpoints.up('sm')]: {
      fontSize: 16,
    },
  },
  active: {
    fontSize: 13,
    fontWeight: 600,
    color: '#000000 !important',
    [theme.breakpoints.up('sm')]: {
      fontSize: 16,
    },
  },
}))(StepLabel);

const useStyles = makeStyles((theme) => {
  return {
    retailStep5: {
      '&:first-child': {
        marginLeft: 'calc(-100% / 5)',
        [theme.breakpoints.up('sm')]: {
          marginLeft: 'calc(-100% / 9.5)',
        },
      },
      '&:last-child': {
        marginRight: 'calc(-100% / 5)',
        [theme.breakpoints.up('sm')]: {
          marginRight: 'calc(-100% / 9.5)',
        },
      },
    },
  };
});

const RetailAppStepper: FC<RetailStepperProps> = (props) => {
  const { activeStep, customerType, isZeroStep = false } = props;
  const classes = useStyles();
  const steps = stepsByCustomerType[String(customerType).toUpperCase()];
  const Step =
    steps.length === 4
      ? RetailStep4
      : (props) => <RetailStep5 {...props} className={isZeroStep ? classes.retailStep5 : ''} />;
  return (
    <StyledStepper activeStep={activeStep} alternativeLabel connector={<RetailStepConnector />}>
      {steps.map((label) => {
        const stepProps: { completed?: boolean } = {};

        return (
          <Step key={label} {...stepProps}>
            <StyledStepLabel StepIconComponent={RetailStepIcon}>{label}</StyledStepLabel>
          </Step>
        );
      })}
    </StyledStepper>
  );
};

export default RetailAppStepper;
